"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Worlds = void 0;
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
exports.Worlds = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'worldsProxyAddress',
                        type: 'address',
                    },
                    { internalType: 'address', name: 'routerContext1', type: 'address' },
                    { internalType: 'address', name: 'routerContext2', type: 'address' },
                    { internalType: 'address', name: 'splitTemplate', type: 'address' },
                    { internalType: 'address', name: 'trustedSigner', type: 'address' },
                    { internalType: 'uint256', name: 'maxWorldId', type: 'uint256' },
                ],
                internalType: 'struct Worlds.WorldsConstructorParams',
                name: 'constructorParams',
                type: 'tuple',
            },
            {
                internalType: 'address',
                name: 'worldsMetadataDelegate',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'DelegateForwarder_For_Internal_Use_Only',
        type: 'error',
    },
    { inputs: [], name: 'ECDSAInvalidSignature', type: 'error' },
    {
        inputs: [{ internalType: 'uint256', name: 'length', type: 'uint256' }],
        name: 'ECDSAInvalidSignatureLength',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'bytes32', name: 's', type: 'bytes32' }],
        name: 'ECDSAInvalidSignatureS',
        type: 'error',
    },
    { inputs: [], name: 'EIP712_Invalid_Signer', type: 'error' },
    { inputs: [], name: 'ERC1167FailedCreateClone', type: 'error' },
    { inputs: [], name: 'ERC721UserRoles_User_Has_No_Roles', type: 'error' },
    {
        inputs: [],
        name: 'ERC721UserRoles_User_Must_Not_Be_Zero_Address',
        type: 'error',
    },
    { inputs: [], name: 'ERC721UserRoles_User_Role_Already_Set', type: 'error' },
    { inputs: [], name: 'InvalidShortString', type: 'error' },
    {
        inputs: [],
        name: 'RouterContextDouble_Router_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint8', name: 'bits', type: 'uint8' },
            { internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'SafeCastOverflowedUintDowncast',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'string', name: 'str', type: 'string' }],
        name: 'StringTooLong',
        type: 'error',
    },
    {
        inputs: [],
        name: 'StringsLibrary_Required_String_Is_Empty',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySeller_Address_0_May_Not_Be_Added',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySeller_No_Sellers_Provided',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySeller_Seller_Already_On_Allowlist',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySeller_Seller_Not_Allowed',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'uint16',
                name: 'minimumTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'WorldsAllowlistBySeller_Take_Rate_Too_Low',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySignature_Invalid_Approval_Type',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySignature_Signer_Is_Required',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Expired',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'maxExpiration', type: 'uint256' },
        ],
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Too_Far_In_Future',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsAllowlist_List_Type_Does_Not_Support_Listing_Identifier',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'maxTakeRate', type: 'uint256' }],
        name: 'WorldsAllowlist_Take_Rate_Above_Max',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsInventoryByNft_Must_Be_Collection_Owner_Or_Admin',
        type: 'error',
    },
    { inputs: [], name: 'WorldsInventoryByNft_Not_In_A_World', type: 'error' },
    {
        inputs: [],
        name: 'WorldsInventoryBySplit_Not_A_Valid_Split',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsInventoryBySplit_Not_Listed_In_A_World',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsInventoryBySplit_Split_Implementation_Not_A_Contract',
        type: 'error',
    },
    { inputs: [], name: 'WorldsManagement_Already_Initialized', type: 'error' },
    {
        inputs: [
            { internalType: 'uint256', name: 'networkMaxWorldId', type: 'uint256' },
        ],
        name: 'WorldsManagement_WorldId_Exceeds_Max_Network_World_Id',
        type: 'error',
    },
    { inputs: [], name: 'WorldsMetadata_Name_Already_Set', type: 'error' },
    {
        inputs: [],
        name: 'WorldsMetadata_Svg_Template_Missing_WorldId_Placeholder',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsNotImplemented_Function_Not_Implemented',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsPaymentInfo_Cannot_Set_Zero_Payment_Address',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'maxTakeRate', type: 'uint256' }],
        name: 'WorldsPaymentInfo_Exceeds_Max_World_Take_Rate',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsPaymentInfo_Payment_Address_Already_Set',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsTransfer2Step_Caller_Not_Token_Owner_Or_Approved',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsTransfer2Step_Cannot_Transfer_To_Current_Owner',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'address', name: 'pendingOwner', type: 'address' },
        ],
        name: 'WorldsTransfer2Step_Not_Pending_Owner_For_Token_Id',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsTransfer2Step_Transfer_To_Already_Initiated',
        type: 'error',
    },
    { inputs: [], name: 'WorldsUserRoles_No_User_Role_Actions', type: 'error' },
    {
        inputs: [],
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Admin_User_Role',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Editor_User_Role',
        type: 'error',
    },
    {
        inputs: [],
        name: 'WorldsUserRoles_Sender_Is_Not_World_Owner',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
        ],
        name: 'AddToAllowlistBySeller',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'takeRateInBasisPoints',
                type: 'uint16',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'listingIdentifier',
                type: 'string',
            },
        ],
        name: 'AddToWorldByCollection',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'nftTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'takeRateInBasisPoints',
                type: 'uint16',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'listingIdentifier',
                type: 'string',
            },
        ],
        name: 'AddToWorldByNft',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'split',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'takeRateInBasisPoints',
                type: 'uint16',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'listingIdentifier',
                type: 'string',
            },
        ],
        name: 'AddToWorldBySplit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'AdminRoleSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approved',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'fromTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'toTokenId',
                type: 'uint256',
            },
        ],
        name: 'BatchMetadataUpdate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
        ],
        name: 'BeginTransfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'defaultTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'DefaultTakeRateSet',
        type: 'event',
    },
    { anonymous: false, inputs: [], name: 'EIP712DomainChanged', type: 'event' },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'EditorRoleSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'MetadataUpdate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'worldPaymentAddress',
                type: 'address',
            },
        ],
        name: 'PaymentAddressSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
        ],
        name: 'RemoveFromAllowlistBySeller',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'nftTokenId',
                type: 'uint256',
            },
        ],
        name: 'RemoveFromWorldByNft',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'marketplace',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalSalePrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'takeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'SoldInWorldByCollection',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'marketplace',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'nftTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'buyer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'salePrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'takeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'SoldInWorldByNft',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'marketplace',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'split',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'valueInWei',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'curatorTakeInWei',
                type: 'uint256',
            },
        ],
        name: 'SoldInWorldBySplit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'worldId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'marketplace',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'split',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'valueInWei',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'curatorTakeInWei',
                type: 'uint256',
            },
        ],
        name: 'SoldInWorldBySplitWorldPaymentFailed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'UserRolesRevoked',
        type: 'event',
    },
    {
        inputs: [],
        name: '_delegateView',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'acceptTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'addToAllowlistBySeller',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address[]', name: 'sellers', type: 'address[]' },
        ],
        name: 'addToAllowlistBySellers',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
            { internalType: 'bytes', name: 'approvalData', type: 'bytes' },
        ],
        name: 'addToWorldByCollectionV2',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'nftTokenId', type: 'uint256' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
            { internalType: 'bytes', name: 'approvalData', type: 'bytes' },
        ],
        name: 'addToWorldByNftForPrimarySale',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'nftTokenId', type: 'uint256' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
            { internalType: 'bytes', name: 'approvalData', type: 'bytes' },
        ],
        name: 'addToWorldByNftV2',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
            {
                internalType: 'address payable',
                name: 'creatorPaymentAddress',
                type: 'address',
            },
            { internalType: 'bytes', name: 'approvalData', type: 'bytes' },
        ],
        name: 'addToWorldBySplitV2',
        outputs: [
            { internalType: 'address payable', name: 'split', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
        ],
        name: 'beginTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'eip712Domain',
        outputs: [
            { internalType: 'bytes1', name: 'fields', type: 'bytes1' },
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'version', type: 'string' },
            { internalType: 'uint256', name: 'chainId', type: 'uint256' },
            { internalType: 'address', name: 'verifyingContract', type: 'address' },
            { internalType: 'bytes32', name: 'salt', type: 'bytes32' },
            { internalType: 'uint256[]', name: 'extensions', type: 'uint256[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'getApproved',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getApprovedRouterAddresses',
        outputs: [
            { internalType: 'address', name: 'routerA', type: 'address' },
            { internalType: 'address', name: 'routerB', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'getAssociationByCollection',
        outputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'nftTokenId', type: 'uint256' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'getAssociationByNft',
        outputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'getAssociationBySplit',
        outputs: [
            { internalType: 'address payable', name: 'split', type: 'address' },
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'split', type: 'address' }],
        name: 'getAssociationBySplitAddress',
        outputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'seller', type: 'address' },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'getDefaultTakeRate',
        outputs: [
            {
                internalType: 'uint16',
                name: 'defaultTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'getPaymentAddress',
        outputs: [
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'getPendingOwner',
        outputs: [
            { internalType: 'address', name: 'pendingOwner', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getTrustedSignerAddress',
        outputs: [{ internalType: 'address', name: 'signer', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'getWorldName',
        outputs: [{ internalType: 'string', name: 'name', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getWorldSplitTemplateAddress',
        outputs: [
            { internalType: 'address', name: 'worldSplitTemplate', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getWorldsMetadataDelegateAddress',
        outputs: [
            {
                internalType: 'address',
                name: 'worldsMetadataDelegate',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'hasAdminRole',
        outputs: [{ internalType: 'bool', name: 'hasRole', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'hasEditorRole',
        outputs: [{ internalType: 'bool', name: 'hasRole', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'networkWorldIdOffset',
                type: 'uint256',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'address', name: 'operator', type: 'address' },
        ],
        name: 'isApprovedForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'isSellerAllowed',
        outputs: [{ internalType: 'bool', name: 'isAllowed', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                components: [
                    { internalType: 'address', name: 'user', type: 'address' },
                    {
                        internalType: 'enum RoleAction',
                        name: 'roleAction',
                        type: 'uint8',
                    },
                ],
                internalType: 'struct UserRoleAction[]',
                name: 'userRoleActions',
                type: 'tuple[]',
            },
        ],
        name: 'manageRolesForUsers',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint16',
                name: 'defaultTakeRateInBasisPoints',
                type: 'uint16',
            },
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'string', name: 'name', type: 'string' },
        ],
        name: 'mint',
        outputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint16',
                name: 'defaultTakeRateInBasisPoints',
                type: 'uint16',
            },
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'address[]', name: 'sellers', type: 'address[]' },
        ],
        name: 'mintWithSellerAllowlist',
        outputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'address[]', name: 'admins', type: 'address[]' },
            { internalType: 'address[]', name: 'editors', type: 'address[]' },
        ],
        name: 'mintWithTeam',
        outputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'ownerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'seller', type: 'address' },
        ],
        name: 'removeFromAllowlistBySeller',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'nftTokenId', type: 'uint256' },
        ],
        name: 'removeFromWorldByNft',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'renounceAllRoles',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'revokeAllRolesForUser',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'setAdminRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'operator', type: 'address' },
            { internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                internalType: 'uint16',
                name: 'defaultTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'setDefaultTakeRate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'setEditorRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
        ],
        name: 'setPaymentAddress',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'seller', type: 'address' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'count', type: 'uint256' },
            { internalType: 'uint256', name: 'totalSalePrice', type: 'uint256' },
        ],
        name: 'soldInWorldByCollection',
        outputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'seller', type: 'address' },
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'nftTokenId', type: 'uint256' },
            { internalType: 'address', name: 'buyer', type: 'address' },
            { internalType: 'uint256', name: 'salePrice', type: 'uint256' },
        ],
        name: 'soldInWorldByNft',
        outputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'uint16', name: 'takeRateInBasisPoints', type: 'uint16' },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'market', type: 'address' },
            { internalType: 'uint256', name: 'valueInWei', type: 'uint256' },
        ],
        name: 'soldInWorldBySplit',
        outputs: [
            {
                internalType: 'address payable',
                name: 'worldPaymentAddress',
                type: 'address',
            },
            { internalType: 'uint256', name: 'curatorTakeInWei', type: 'uint256' },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'market', type: 'address' },
            { internalType: 'uint256', name: 'valueInWei', type: 'uint256' },
        ],
        name: 'soldInWorldBySplitWorldPaymentFailed',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: 'isSupported', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'worldId', type: 'uint256' }],
        name: 'tokenURI',
        outputs: [{ internalType: 'string', name: 'uri', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            { internalType: 'string', name: 'name', type: 'string' },
        ],
        name: 'updateWorldName',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
//# sourceMappingURL=Worlds.generated.js.map